import { fetchJsonWithAuth } from './dropdownApi';
import { AUTH_URL } from './apiConfig';

/* Activity + Notes for the detail view's right-rail card. Both hit the
   authapi/v1 service and unwrap the { status, data } envelope. */

const unwrap = (json) => json?.data ?? json;

// GET /module-activity?module={module}&id={id} → a record's activity entries,
// newest first. One common endpoint for every module (jobs/candidates/…).
export async function getActivity(module, id) {
  if (!module || !id) return [];
  const params = new URLSearchParams({ module, id: String(id) });
  const json = await fetchJsonWithAuth(AUTH_URL, `/module-activity?${params.toString()}`);
  const data = unwrap(json);
  return Array.isArray(data) ? data : [];
}

// GET /notes?relatedId={id} → notes attached to a record, newest first.
export async function getNotes(relatedId) {
  if (!relatedId) return [];
  const json = await fetchJsonWithAuth(AUTH_URL, `/notes?relatedId=${encodeURIComponent(relatedId)}`);
  const data = unwrap(json);
  return Array.isArray(data) ? data : [];
}

// POST /notes → add a note against a related record. `notesFor` is the module
// (e.g. "job") — it tags the note and lets the backend log the matching
// activity entry on the right record.
export async function createNote({ relatedId, notes, title, notesFor }) {
  const json = await fetchJsonWithAuth(AUTH_URL, '/notes', {
    method: 'POST',
    body: JSON.stringify({ relatedId, notes, title, notesFor }),
  });
  return unwrap(json);
}
